import React from 'react';
import { Box } from '@mui/material';
import { trialStatusLabel } from '../../utils/portfolioDesignResults';

export default function SearchPoint({ cx, cy, row, color, selected, arriving, onChoose }) {
    const failed = row.status === 'infeasible';
    const unfinished = !failed && row.status !== 'verified';
    const action = row.status === 'verified' ? 'Click to load this portfolio.' : 'Click to inspect this attempt.';
    return <Box component="g" role="button" tabIndex={0}
        onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onChoose?.(row.index); }
        }} transform={`translate(${cx},${cy})`} data-run-status={row.status} aria-label={`Run ${row.number} · ${trialStatusLabel[row.status]}`}
        sx={{ cursor: 'pointer', outline: 'none',
            '& .search-point-hover': { opacity: 0, transition: 'opacity 120ms ease-out' },
            '&:hover .search-point-hover, &:focus-visible .search-point-hover': { opacity: 1 },
            '@keyframes searchPointArrival': { from: { r: 5, opacity: 0.9 }, to: { r: 22, opacity: 0 } },
            '& .search-point-arrival': { animation: 'searchPointArrival 1.4s ease-out forwards' },
            '@media (prefers-reduced-motion: reduce)': { '& .search-point-hover': { transition: 'none' }, '& .search-point-arrival': { animation: 'none', display: 'none' } } }}>
        <title>{action}</title>
        <circle r={10} fill="transparent" />
        <circle className="search-point-hover" r={11} fill={color} fillOpacity={0.18} stroke={color} strokeWidth={2} />
        {arriving && <circle className="search-point-arrival" data-testid={`arrival-${row.index}`} r={5} fill="none" stroke={color} strokeWidth={3} />}
        {selected && <circle r={14} fill={color} opacity={0.18} />}
        {failed ? <path d="M-4,-4l8,8m-8,0l8,-8" stroke={color} strokeWidth={2} />
            : unfinished ? <rect x={-4} y={-4} width={8} height={8} fill="transparent" stroke={color} />
                : <circle r={selected ? 7 : 4.5} fill={color} stroke={selected ? '#fff' : 'transparent'} strokeWidth={2} opacity={selected ? 1 : 0.85} />}
    </Box>;
}
